import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout, publicGetExcursions } from '../../api';
import { AuthContext } from '../../App';
import { t, useLang } from '../../i18n';
import { Icon, LangSwitcher } from './Kit';
import '../../styles/vod.css';
import './screens.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const BASE = API_URL.replace('/api', '');

function Menu() {
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);
  return (
    <div className="vod-lang" ref={ref}>
      <button type="button" className="vod-round icon" onClick={() => setOpen(o => !o)} aria-label={t('menu')}>{Icon.menu()}</button>
      {open && (
        <div className="vod-lang-menu" style={{ insetInlineStart: 0, insetInlineEnd: 'auto' }}>
          {user && <button type="button" disabled style={{ opacity: .7, cursor: 'default' }}><span dir="auto">{user.name}</span></button>}
          {user && user.is_admin && <button type="button" onClick={() => navigate('/admin')}>Admin</button>}
          <button type="button" onClick={async () => { await logout(); setUser(null); navigate('/', { replace: true }); }}>{t('logout')}</button>
        </div>
      )}
    </div>
  );
}

export default function ExcursionListScreen() {
  const lang = useLang();
  const [list, setList] = useState(null);

  useEffect(() => {
    setList(null);
    publicGetExcursions().then(setList).catch(() => setList([]));
  }, [lang]);

  return (
    <main className="vod vod-screen cream" style={{ padding: 'calc(env(safe-area-inset-top, 0px) + 34px) 16px calc(env(safe-area-inset-bottom, 0px) + 24px)' }}>
      <img className="vodl-deco palm" src="/deco-palm.png" alt="" />
      <img className="vodl-deco sky" src="/deco-skyline.png" alt="" />

      <div className="vodl-top">
        <div className="vodl-corner start"><Menu /></div>
        <img className="vodl-logo" src="/logo-light.png" alt="Voice of Dubai" />
        <div className="vodl-corner end"><LangSwitcher withGlobe={false} /></div>
      </div>

      <h1 className="vodl-title vod-serif">{t('choose_excursion')}</h1>
      <p className="vodl-tagline">{t('explore_listen')}</p>

      <div className="vodl-list">
        {list === null && <div className="vod-loading">{t('loading')}</div>}
        {list && list.length === 0 && <div className="vod-loading">{t('no_excursions')}</div>}
        {list && list.map(e => (
          <Link key={e.id} className="vodl-tour" to={`/excursion/${e.id}`}>
            {e.image_url ? <img src={BASE + e.image_url} alt="" /> : <div className="vodl-noimg" />}
            <div className="vodl-body">
              <div className="vodl-label">{Icon.headphones({ size: 18, color: '#B8893A', sw: 1.8 })} {t('audio_walk')}</div>
              <h2 className="vodl-name vod-serif" dir="auto">{e.title}</h2>
              {e.subtitle && <div className="vodl-place" dir="auto">{e.subtitle}</div>}
              <div className="vodl-bottom">
                {e.duration_min > 0 && <>{Icon.clock({ size: 17, color: '#5E6272', sw: 1.8 })}<span>{t('min', { n: e.duration_min })}</span></>}
                {!(e.duration_min > 0) && <span />}
                <i className="vodl-go">{Icon.chevron()}</i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
